<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Search Questions
    </div>
    <div class="card-header nocollapse bg-info col-md-12 msg-container" *ngIf="successOrFailureMessage!==''">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="search-toolbar p-2">
      <form [formGroup]="questionCategoryForm" class="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div class="d-flex align-items-center gap-2">
          <label class="form-control-label mb-0 fw-500" for="questionCategoryId">Category</label>
          <select name="questionCategoryId" id="questionCategoryId" formControlName="questionCategoryId"
                  class="form-control form-control-sm" style="width: 280px;" (change)="onQuestionCategoryChange()">
            <option value="" selected>-- Select Category --</option>
            <option *ngFor="let item of questionCategoryList" [ngValue]="item?.questionCategoryId"
                    [selected]="questionCategoryId==item?.questionCategoryId">
              {{item.questionCategoryName}}
            </option>
          </select>
        </div>
        <button type="button" class="btn btn-primary btn-action" (click)="BackUrl()">
          <i class="fa fa-home"></i> Home
        </button>
      </form>
    </div>
    <!--<br />-->
    <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
    <isg-grid
      [rowData]="gridQuestionList"
      [columnDefs]="columnDefs"
      [config]="gridConfig"
      (rowSelected)="onRowChecked($event)"
      (gridReady)="onFolderGridReady($event)">
    </isg-grid>

    <div class="modal fade" id="deleteQuestionConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteQuestionModel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Delete Question/Folder Confirmation</h5>
            <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete the selected question(s)/folder(s)?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-modal" data-dismiss="modal"><i class="fa fa-times"></i> Close</button>
            <button type="button" class="btn btn-danger btn-modal" data-dismiss="modal" (click)="deleteQuestions()"><i class="fa fa-trash"></i> Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
